import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl';
import commonFunctions from '../../../utils/commonFunctions';
import 'react-phone-number-input/style.css'
import constants from '../../../utils/constants'
import strings from '../../../utils/strings'
import API from '../../../utils/API';

const modalId = 'moderationModal';

function AlertUsersModerationModal(props) {
  const { closeModal } = commonFunctions;
  const { setSuccess, setError } = props;
  const [aplusMode, setAplusMode] = useState('moderated');

  useEffect(()=>{
    API.getAplusMode()
    .then((res)=>{
      setAplusMode(res.data.mode);
    })
  }, [])

  const onSave = async () => {
    try {
      await API.putAplusMode(aplusMode)
      setSuccess(<FormattedMessage id="MODERATION_OPTIONS_SAVE_SUCCESS" />);
    } catch (error) {
      setError(<FormattedMessage id="MODERATION_OPTIONS_SAVE_FAIL" />);
    }

    closeModal(modalId);
  }

  // console.log(mode);
  return (
    <div className="modal fade" id={modalId} tabIndex="-1" aria-labelledby="moderationModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><FormattedMessage id="MODERATION_OPTIONS" defaultMessage={"Moderation Options"} /></h5>
            <button type="button" id="closeModerationModal" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
          <div className="form-check">
            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked={aplusMode === 'moderated' ? true : false} onChange={()=>{setAplusMode('moderated')}}/>
            <label className="form-check-label">
                <div style={{fontWeight: 'bolder'}}><FormattedMessage id="TEACHERS_NEED_APPROVAL"/></div>
                <FormattedMessage id="TEACHERS_NEED_APPROVAL_DESCRIPTION"/>
            </label>
          </div>
          <div className="form-check">
            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" checked={aplusMode === 'unmoderated' ? true : false} onChange={()=>{setAplusMode('unmoderated')}}/>
            <label className="form-check-label">
                <div style={{fontWeight: 'bolder'}}><FormattedMessage id="TEACHERS_TRIGGER_IMMEDIATELY"/></div>
                <FormattedMessage id="TEACHERS_TRIGGER_IMMEDIATELY_DESCRIPTION"/>
            </label>
          </div>
          </div>
          <div className="modal-footer justify-content-between">
            <button className="btn back-btn" type="button" data-bs-dismiss="modal"><FormattedMessage id="BACK" /></button>
            <button className="btn save-btn ms-2" type="submit" onClick={onSave}><FormattedMessage id="SAVE" /></button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AlertUsersModerationModal